<template>
	<WorkIt>
		<Intro
			title="Corporate Identity"
			subtitle="Various">
			<p>To convey the essence of a business in a small space is both challenging and rewarding. Without fail, every company wants to make their logo bigger… my goal is to make sure it’s something they are truly proud of.</p>
		</Intro>

		<div class="px14">
			<img class="m-auto mb12 hidden sm:block" src="/img/corportate-identity-logo-min.png" srcset="/img/corportate-identity-logo@2x-min.png 2x" alt="" />

			<img class="m-auto sm:hidden" src="/img/corporate-identity-logo-m-min.png" srcset="/img/corporate-identity-logo-m@2x-min.png 2x" alt="" />
		</div>

		<FooterNav prev="/work/websites"></FooterNav>
	</WorkIt>
</template>

<script>
import Intro from '@/components/Intro.vue';
import WorkIt from '@/components/WorkIt.vue';
import FooterNav from '@/components/FooterNav.vue';

import { mapMutations } from 'vuex';

export default {
	components: {
		Intro,
		WorkIt,
		FooterNav
	},
	methods: {
		...mapMutations([
			'APP_CLASS'
		])
	},
	created: function() {
		this.APP_CLASS('page-work work-detail corporate-identity');
	}
}
</script>